import { Component, OnDestroy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { TranslateService } from '@ngx-translate/core';
import { event } from 'jquery';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'btn-cell-rendererGambaWalk',
  template: `
    <button *ngIf="(params.node.data.ObservationStatus!=='Closed' && params.node.data.ObservationStatus!=='Completed')"
     mat-mini-fab color="primary"
     tooltipPosition="top"
     [pTooltip]="t('EditGembaWalk', 'Edit GembaWalk')"
     (click)="onClick($event)">
      <mat-icon>edit</mat-icon>
    </button>
    <button *ngIf="(params.node.data.ObservationStatus!=='Closed' && params.node.data.ObservationStatus!=='Completed'  && params.node.data.ObservationStatus.toLowerCase() !== 'in progress' )"
      mat-mini-fab
      tooltipPosition="top"
      [pTooltip]="t('DeleteGembaWalk', 'Delete GembaWalk')"
      color="warn"
      (click)="onClick($event)"
    >
      <mat-icon>delete</mat-icon>
    </button>
    <button *ngIf="(params.node.data.ObservationStatus!=='Closed' && params.node.data.ObservationStatus!=='Completed')"
      mat-mini-fab
      color="accent"
      tooltipPosition="top"
      [pTooltip]="t('AddAction', 'Add Action')"
      (click)="onClick($event)"
      class="add-icon"
    >
      <mat-icon>add</mat-icon>
    </button>
    <button *ngIf= "params.node.data.ObservationStatus !== 'Closed' && params.node.data.ObservationStatus.toLowerCase() !== 'in progress' && params.node.data.NoOfActions === 0 "
      mat-mini-fab
      color="accent"
      tooltipPosition="top"
      [pTooltip]="t('CloseGembaWalk', 'Close GembaWalk')"
      (click)="onClick($event)"
    >
      <mat-icon>close</mat-icon>
    </button>
    <button *ngIf= "params.node.data.ObservationStatus === 'Closed' && params.node.data.NoOfActions === 0"
      mat-mini-fab
      color="accent"
      tooltipPosition="top"
      [pTooltip]="t('ViewActions', 'View Actions')"
      (click)="onClick($event)"
    >
      <mat-icon>remove_red_eye</mat-icon>
    </button>
    <button style="background-color: #7a1dcf;"
    *ngIf= "params.node.data.ObservationStatus === 'Closed' ? false: true "
    tooltipPosition="top"
    [pTooltip]="t('ViewImage', 'View Image')"
      mat-mini-fab
      (click)="onClick($event)"
    >
    <mat-icon> insert_drive_file</mat-icon>
    </button>

    <button style="background-color: #6FBABA;"
    *ngIf= "params.node.data.NoOfActions > 0"
    tooltipPosition="top"
     [pTooltip]="t('ViewActions', 'View Actions')"
      mat-mini-fab
      (click)="onClick($event)"
    >
    <mat-icon>remove_red_eye</mat-icon>
    </button>
  `,
  styles: [
    ` button{
      height: 35px;
      width: 35px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      margin: 0 3px;

    }
    .mat-icon {
      transform: scale(0.7);
    }
      .add-icon {
        background: cornflowerblue;
      }
    `,
  ],
})
export class BtnCellRendererGambaWalk
  implements ICellRendererAngularComp, OnDestroy {
  clicked = false;
  params: any;
  extraProperty: any;

  constructor(public translate: TranslateService) {}

  /** i18n section for the host page in assets/i18n/*.json */
  private readonly PAGE = 'GembaWalk';

  /**
   * Resolve a tooltip: the host page's langObj (flat) -> "<PAGE>.<key>" in the
   * i18n file -> the flat "<key>" for strings shared with other pages -> English.
   */
  t(key: string, fallback: string): string {
    const langObj =
      this.params && typeof this.params.getLangObj === 'function'
        ? this.params.getLangObj()
        : null;
    if (langObj && langObj[key]) {
      return langObj[key];
    }
    const scoped = `${this.PAGE}.${key}`;
    const scopedValue = this.translate.instant(scoped);
    if (typeof scopedValue === 'string' && scopedValue !== scoped) {
      return scopedValue;
    }
    const flatValue = this.translate.instant(key);
    if (typeof flatValue === 'string' && flatValue !== key) {
      return flatValue;
    }
    // a key naming a whole page section resolves to an object, not a string
    if (flatValue && typeof flatValue === 'object' && typeof flatValue.title === 'string') {
      return flatValue.title;
    }
    return fallback;
  }

  refresh(params: any): boolean {
    throw new Error('Method not implemented.');
  }

  agInit(params: any): void {
    this.params = params;
    params.getExtraProperty((value: boolean) => {
      this.extraProperty = value;
    });
  }
  onClick($event: any): any {

    const spec = $event.target.className;
    if (
      spec !== 'Delete' &&
      spec !== 'close' &&
      this.params.node.data.ObservationStatus.toLowerCase() !== 'in progress'
    ) {
      if (this.params.onClick instanceof Function) {
        // put anything into params u want pass into parents component
        const params = {
          event: $event,
          rowData: this.params.node.data,
          // ...something
        };
        this.params.onClick(params);
      }
    } else {
      this.clicked = true;
    }
  }
  ngOnDestroy(): any {
    // no need to remove the button click handler
    // https://stackoverflow.com/questions/49083993/does-angular-automatically-remove-template-event-listeners
  }
}
